import { CrewEvaluationCategory } from '../../../types';

export const defaultCategories: CrewEvaluationCategory[] = [
  {
    id: '1',
    name: 'Technical Skills',
    categoryRating: 0,
    items: [
      { id: '1-1', criteriaName: 'Equipment Operation', rating: 0, comments: '' },
      { id: '1-2', criteriaName: 'Technical Knowledge', rating: 0, comments: '' },
      { id: '1-3', criteriaName: 'Problem Solving', rating: 0, comments: '' },
      { id: '1-4', criteriaName: 'Safety Compliance', rating: 0, comments: '' }
    ]
  },
  {
    id: '2',
    name: 'Communication Skills',
    categoryRating: 0,
    items: [
      { id: '2-1', criteriaName: 'English Proficiency', rating: 0, comments: '' },
      { id: '2-2', criteriaName: 'Team Communication', rating: 0, comments: '' },
      { id: '2-3', criteriaName: 'Report Writing', rating: 0, comments: '' },
      { id: '2-4', criteriaName: 'Following Instructions', rating: 0, comments: '' }
    ]
  },
  {
    id: '3',
    name: 'Work Attitude',
    categoryRating: 0,
    items: [
      { id: '3-1', criteriaName: 'Punctuality', rating: 0, comments: '' },
      { id: '3-2', criteriaName: 'Initiative', rating: 0, comments: '' },
      { id: '3-3', criteriaName: 'Reliability', rating: 0, comments: '' },
      { id: '3-4', criteriaName: 'Teamwork', rating: 0, comments: '' }
    ]
  },
  {
    id: '4',
    name: 'Leadership & Management',
    categoryRating: 0,
    items: [
      { id: '4-1', criteriaName: 'Leadership Skills', rating: 0, comments: '' },
      { id: '4-2', criteriaName: 'Decision Making', rating: 0, comments: '' },
      { id: '4-3', criteriaName: 'Delegation', rating: 0, comments: '' },
      { id: '4-4', criteriaName: 'Conflict Resolution', rating: 0, comments: '' }
    ]
  }
];
